<div class="container-fluid admin-page airport-cars-page">
    <header class="admin-page-header">
        <div>
            <h1>{{ 'Airport cars' | translate }}</h1>
            <p>{{ 'View the current airport queue and select a car to inspect its details.' | translate }}</p>
        </div>
        <div class="admin-header-actions">
            <button (click)="getAirportCars()" class="admin-refresh-button" type="button">
                <i class="material-icons">refresh</i><span>{{ 'Refresh' | translate }}</span>
            </button>
        </div>
    </header>

    <div *ngIf="showNoCarsMessage" class="empty-state admin-page-state">
        <i class="material-icons">local_airport</i>
        <span>{{ 'Currently there are no cars in the airport queue.' | translate }}</span>
    </div>

    <div *ngIf="!showNoCarsMessage" class="airport-cars-list">
        <button (click)="showCarDetails(item)" *ngFor="let item of airportCars" class="airport-car-card"
                type="button">
      <span class="airport-car-icon">
        <i class="material-icons">directions_car</i>
      </span>
            <span class="airport-car-content">
        <span class="airport-car-label">{{ 'Airport queue' | translate }}</span>
        <strong>{{ item }}</strong>
      </span>
        </button>
    </div>
</div>

<ng-template #dialogsContainerAirport></ng-template>
